import {
  useMutation,
  useQueryClient,
  type UseMutationOptions,
} from '@tanstack/react-query';
import { toast } from '@/shared/hooks/use-toast';
import { presetApi } from '@/features/presets/api';
import { packKeys } from './pack.keys';

type RemovePresetResponse = { id: string; deleted: boolean };

export function useRemovePreset(
  packId?: string,
  options?: UseMutationOptions<RemovePresetResponse, Error, string>
) {
  const queryClient = useQueryClient();
  const { onSuccess: providedOnSuccess, onError: providedOnError, ...mutationOptions } = options ?? {};
  const mutation = useMutation({
    mutationKey: ['packs', 'remove-preset'],
    mutationFn: presetApi.remove,
    ...mutationOptions,
    onSuccess: (_, presetId, context) => {
      if (packId) {
        queryClient.invalidateQueries({ queryKey: packKeys.presets(packId) });
      }
      queryClient.invalidateQueries({ queryKey: packKeys.all });
      providedOnSuccess?.(_, presetId, context);
    },
    onError: (error, variables, context) => {
      toast({
        title: 'Erro ao remover preset',
        description: error.message,
        variant: 'destructive',
      });
      providedOnError?.(error, variables, context);
    },
  });
  const removePreset = (presetId: string) => mutation.mutateAsync(presetId);
  return {
    removePreset,
    isLoading: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
    mutationResult: mutation,
  };
}
